// Provider
export { TranslationProvider } from "./TranslationProvider.js";
// Hooks and utilities
export { useAppTranslation, withTranslation, getTranslation, extractTranslations } from "./useAppTranslation.js";
// Components
export { AppTrans } from "./AppTrans.js";
// Configuration
export { default as i18n } from "./config.js";
// Export locale data for direct use if needed
export { default as commonEn } from "./locales/common-en.json";
export { default as commonEs } from "./locales/common-es.json";
export { default as commonFr } from "./locales/common-fr.json";
export { default as commonKo } from "./locales/common-ko.json";
export { default as commonJa } from "./locales/common-ja.json";
// Export all locales as a map for convenience
export const locales = {
    en: () => import("./locales/common-en.json"),
    es: () => import("./locales/common-es.json"),
    fr: () => import("./locales/common-fr.json"),
    ko: () => import("./locales/common-ko.json"),
    ja: () => import("./locales/common-ja.json"),
};
// Export supported language codes
// IMPORTANT: If you add or remove languages here, you MUST also update:
// - infrastructure/website/src/website-construct.ts (SUPPORTED_LANGUAGES constant)
export const supportedLanguages = ["en", "es", "fr", "ko", "ja"];
// Bootstrap API
export { bootstrapWithTranslations } from "./bootstrap.js";
